import React, { useEffect, useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import marketMap from "../assets/lottie-files/marketMap.lottie";
import SectionTitle from "../components/SectionTitle";

const MarketMapFromWP = () => {
  const [loading, setLoading] = useState(true);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const containerId = "market-map-embed-container";

    const container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = "";

    // Remove old script if it exists (important)
    const oldScript = document.querySelector(
      'script[src="https://app.marketwurks.com/assets/embed.js"]'
    );
    if (oldScript) {
      oldScript.remove();
    }

    const script = document.createElement("script");
    script.src = "https://app.marketwurks.com/assets/embed.js";
    script.async = true;

    script.setAttribute(
      "data-resource-id",
      "markets/ba71b3f11ef9ca2fa42b987c5425d5dc"
    );
    script.setAttribute("data-org-id", "2059e9ddd0a241ff86ccb7d0189dbe64");

    script.onload = () => {
      setLoading(false);
      setFadeIn(true);
    };

    // 🔑 CRITICAL: append script NEXT TO container, not body
    container.appendChild(script);
  }, []);

  return (
    <>
      <div
        style={{
          background:
            "linear-gradient(to bottom right, #D46540 65%, rgb(253, 243, 187) 100%)",
          padding: "4rem 1rem",
          color: "white",
        }}
      >
        <div style={styles.contentWrapper}>
          <div style={styles.textWrapper}>
            <SectionTitle
              parts={[{ text: "🎪 Market Site Map" }]}
              align="left"
            />
            <p style={{ fontSize: "1.25rem", lineHeight: "1.6" }}>
              View our full vendor layout and locations across the market
            </p>
          </div>
          <div style={styles.lottieWrapper}>
            <DotLottieReact
              src={marketMap}
              autoplay
              loop
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          background: "#fff",
          padding: "2.5rem 1rem",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "2rem 0",
          }}
        >
          {loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "1rem",
                fontSize: "1rem",
                color: "#D46540",
              }}
            >
              Loading map...
            </div>
          )}

          <div
            id="market-map-embed-container"
            style={{
              background: "#f8f8f8",
              borderRadius: "1rem",
              padding: "2rem",
              minHeight: "300px",
              boxShadow: "0 2px 12px rgba(212,101,64,0.07)",
              opacity: fadeIn ? 1 : 0,
              transition: "opacity .6s ease-in-out",
            }}
          ></div>
        </div>
      </div>
    </>
  );
};

const styles = {
  contentWrapper: {
    maxWidth: 1200,
    margin: "0 auto",
    display: "flex",
    flexWrap: "wrap" as const,
    justifyContent: "space-between",
    alignItems: "center",
    gap: "2rem",
  },
  textWrapper: {
    flex: "1 1 500px",
    minWidth: "300px",
  },
  lottieWrapper: {
    flex: "1 1 400px",
    minWidth: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default MarketMapFromWP;
